import { render, staticRenderFns } from "./ManageDeals.vue?vue&type=template&id=5c4bf83b&scoped=true&"
import script from "./ManageDeals.vue?vue&type=script&lang=js&"
export * from "./ManageDeals.vue?vue&type=script&lang=js&"
import style0 from "./ManageDeals.vue?vue&type=style&index=0&id=5c4bf83b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4bf83b",
  null
  
)

export default component.exports